import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from '@mui/material';
import {
  AccountDataPoint,
  ReportingPeriod
} from 'generated/graphql';
import _ from 'lodash';



export type CompanyYearlyDataTableProps = {
  dataPoints: AccountDataPoint[];
  growthRate: AccountDataPoint[];
  showQuarters: boolean;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: CompanyYearlyDataTableProps) => {
  const keys: ReportingPeriod[] = [
    'q1',
    'q2',
    'q3',
    'q4',
    'fy'
  ];



  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {props.showQuarters && (
              <TableCell />
            )}

            <TableCell>
              {props.dataPoints[0]?.year}
            </TableCell>

            <TableCell>
              Growth
            </TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {keys.map((period) => {
            const growthRate = props.growthRate.find((node) => node.period === period);
            const value = props.dataPoints.find((n) => n.period === period);

            return (
              <TableRow key={period}>
                {props.showQuarters && (
                  <TableCell sx={{
                    paddingLeft: 0,
                    borderTop: period === 'fy' ? '1px solid #e0e0e0' : 'initial'
                  }}
                  >
                    {period.toUpperCase()}
                  </TableCell>
                )}

                <TableCell sx={{
                  paddingLeft: 0,
                  borderTop: period === 'fy' ? '1px solid #e0e0e0' : 'initial'
                }}
                >
                  {value?.formattedValue ?? '-'}
                </TableCell>

                <TableCell sx={{
                  paddingLeft: 0,
                  borderTop: period === 'fy' ? '1px solid #e0e0e0' : 'initial',
                  color: (!_.isNil(growthRate))
                    ? (growthRate.value.gt(0) ? 'green' : 'red')
                    : undefined
                }}
                >
                  {!_.isNil(growthRate) ? growthRate.formattedValue : '-'}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
